import React from "react";
import styled from "styled-components/macro";
import {
  CONSTANTS,
  COLORS,
  FONTWEIGHT,
  FONTSIZE,
  BREAKPOINTS
} from "helpers/designConstants";
import MenuIcon from "@mui/icons-material/Menu";

import LanguageDropdownMenu from "components/shared/LanguageDropdownMenu";

const BookingPublicLayout = ({
  title,
  subTitle,
  pageHeaderRight,
  showMenuButton,
  onMenuToggle,
  children
}) => {
  return (
    <PageWrapper>
      <PageHeader>
        <LeftSideHeaderWrapper>
          {showMenuButton && (
            <MenuButton onClick={onMenuToggle}>
              <MenuIcon />
            </MenuButton>
          )}
          <DesktopLogo src='/icon-adidas-logo.svg' />
          <Spacer />
          <LanguageDropdownMenu alignLeftOrRight='left' />
        </LeftSideHeaderWrapper>
        <PageTitleWrapper>
          <PageTitle>{title}</PageTitle>
          <PageSubtitle>{subTitle}</PageSubtitle>
        </PageTitleWrapper>
        <RightSideHeaderWrapper>
          {showMenuButton && <MobileLogo src='/icon-adidas-logo.svg' />}
          {pageHeaderRight}
        </RightSideHeaderWrapper>
      </PageHeader>
      <ContentWrapper>{children}</ContentWrapper>
    </PageWrapper>
  );
};

const MenuButton = styled.div`
  display: none;
  cursor: pointer;
  color: ${COLORS.text};
  margin-right: 8px;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    display: flex;
    align-items: center;
  }
`;

const PageWrapper = styled.div`
  width: 100%;
  max-width: ${({ isMobile }) => (isMobile ? "unset" : "1350px")};
  height: 100%;
  display: grid;
  grid-template-rows: min-content 1fr;
`;

const PageHeader = styled.div`
  margin: 10px;
  padding: 10px;
  border: 1px solid ${COLORS.secondary};
  border-radius: ${CONSTANTS.borderRadius};
  background-color: ${COLORS.tertiary};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    margin: 5px;
    padding: 8px;
    grid-template-columns: auto 1fr auto;
  }
`;

const LeftSideHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const DesktopLogo = styled.img`
  height: 40px;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    display: none;
  }
`;

const Spacer = styled.div`
  margin: 0 15px;
  padding: 15px 0;
  width: 1px;
  background-color: ${COLORS.text};

  @media (max-width: ${BREAKPOINTS.mobile}) {
    display: none;
  }
`;

const RightSideHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MobileLogo = styled.img`
  height: 24px;
  display: none;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    display: block;
  }
`;

const PageTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PageTitle = styled.div`
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  color: ${COLORS.text};
  font-size: ${FONTSIZE.large};
  font-weight: ${FONTWEIGHT.heavy};

  @media (max-width: ${BREAKPOINTS.mobile}) {
    font-size: ${FONTSIZE.small};
  }
`;

const PageSubtitle = styled.div`
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  color: ${COLORS.text};
  font-size: ${FONTSIZE.small};
  font-weight: ${FONTWEIGHT.heavy};
`;

const ContentWrapper = styled.div`
  margin: 10px 10px 30px;
  overflow: hidden;
  border: 1px solid ${COLORS.secondary};
  border-radius: ${CONSTANTS.borderRadius};
  position: relative;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    margin: 5px 5px 10px;
  }
`;

export default BookingPublicLayout;
